import { Box, Card, CardContent, Divider, Paper, Stack, Typography, responsiveFontSizes } from "@mui/material"
import QRCode from "react-qr-code"
import moment from "moment";

import BagongPilipinasLogo from "../../../assets/Bagong_Pilipinas_logo.png";
import SBMALogo from "../../../assets/Sbma_logo.png";
import PhilippinePortLogo from "../../../assets/Philippine_Ports_Authority_logo.png";
import { Grid } from "react-loader-spinner";

const EIDComponent = ({ref, details, eIDQRCode}) => {
    return(
        <Paper
        ref={ref}
        elevation={8}
        sx={{
            width: "100%",
            height: "100%",
            maxWidth: 640, 
            border: `1px solid #e5edf6`,
            borderRadius: 5,
            boxShadow: 3,
        }}
        >
            <Box sx={{p: 2}}>
                {/* Logos Row */}
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={{ xs: 2, sm: 4 }}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    {[BagongPilipinasLogo, SBMALogo, PhilippinePortLogo].map((src, i) => (
                    <Box
                        key={i}
                        component="img"
                        src={src}
                        sx={{
                        width: '100%',
                        maxWidth: 80,
                        height: 'auto',
                        objectFit: 'contain',
                        }}
                    />
                    ))}
                </Stack>

                {/* Details Section */}
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={3}
                    sx={{
                    justifyContent: "space-between",
                    alignItems: "stretch",
                    mt: 1
                    }}
                >
                    {/* Personal Info */}
                    <Stack
                    direction="column"
                    flex={2}
                    sx={{
                        justifyContent: "center",
                        alignItems: { xs: "center", md: "flex-start" },
                        textAlign: { xs: "center", md: "left" },
                    }}
                    >
                    <Stack spacing={1}>
                        <Typography variant="subtitle2" fontSize={"0.55rem"}>Apelyido/Last Name</Typography>
                        <Typography fontWeight="bold" fontSize={"0.65rem"}>{details?.lastname}</Typography>

                        <Typography variant="subtitle2" fontSize={"0.55rem"}>Mga Pangalan/Given Names</Typography>
                        <Typography fontWeight="bold" fontSize={"0.65rem"}>{details?.firstname}</Typography>

                        <Typography variant="subtitle2" fontSize={"0.55rem"}>Gitnang Apelyido/Middle Name</Typography>
                        <Typography fontWeight="bold" fontSize={"0.65rem"}>{details?.middlename}</Typography>

                        <Typography variant="subtitle2" fontSize={"0.55rem"}>Petsa ng Kapanganakan/Date of Birth</Typography>
                        <Typography fontWeight="bold" fontSize={"0.65rem"}>
                        {moment(details?.birthdate).format("MMMM DD, YYYY")}
                        </Typography>
                    </Stack>
                    </Stack>

                    {/* QR Code and Info */}
                    <Stack
                    direction="column"
                    flex={1}
                    spacing={1}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        pt: { xs: 3, md: 0 },
                    }}
                    >
                        <div style={{ height: "auto", margin: "0 auto", maxWidth: 100, width: "100%" }}>
                            <QRCode
                                style={{ height: "auto", maxWidth: "100%", width: "100%"}}
                                value={eIDQRCode}
                            />
                        </div>
                        <Typography fontWeight="bold" fontSize={"0.65rem"}>{details?.id_no}</Typography>
                        <Typography variant="subtitle2" fontSize={"0.65rem"}>
                            {details?.profile_type ? details.profile_type : ""} -{" "}
                            {details?.role ? details.role : ""}
                        </Typography>
                    </Stack>

                    {/* Rotated ID */}
                    <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        justifyContent: { xs: "flex-end", md: "flex-end" },
                        alignItems: "center",
                        mt: { xs: 2, md: 0 },
                    }}
                    >
                        <Box
                            sx={{
                            transform: 'rotate(90deg)',
                            transformOrigin: 'right bottom',
                            whiteSpace: 'nowrap',
                            fontSize: '0.55rem',
                            mr: { xs: 1, md: 1 },
                            mt: { xs: -25, md: 25 },
                            }}
                        >
                            ID: <b>{details?.eid_no}</b>
                        </Box>
                    </Box>
                </Stack>
                {/* Footer */}
                <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
                    <Typography fontWeight="bold" fontSize={"0.65rem"}>NextIX Inc.</Typography>
                </Stack>
            </Box>
        </Paper>
    )
}

export default EIDComponent